import { Suspense, lazy, FC } from 'react';

const AuctionItemSubscriptionError = lazy(
    () =>
        import(
            /* webpackChunkName: "AuctionItemSubscriptionError" */ './AuctionItemSubscriptionError'
        )
);

type Props = {
    hasSubscriptionError: boolean;
    afterDisplay: boolean;
};

export const AuctionItemSubscriptionErrorLazy: FC<Props> = ({
    hasSubscriptionError,
    afterDisplay,
}) => {
    if (!afterDisplay) {
        return null;
    }
    return (
        <Suspense fallback={null}>
            <AuctionItemSubscriptionError hasSubscriptionError={hasSubscriptionError} />
        </Suspense>
    );
};
